<template>
    <div>
        <a-modal v-model="isVisible" :closable="false" title="Adjust pickup time" on-ok="handleOk">
            <template slot="footer">
                <a-button type="primary" @click="handleBtnUpdate">
                    Update
                </a-button>

                <a-button key="back" @click="handleBtnCancel">
                    Close
                </a-button>
            </template>
            <a-row>
                <a-form-model ref="pickupTimeEditForm"
                            :model="pickupTimeEditModel"
                            :rules="pickupTimeEditRules"
                >
                    <a-row :gutter="[24]">
                        <a-col :span="12">
                            <a-form-model-item label="Current pickup Time">
                                <a-time-picker format="HH:mm" 
                                            v-model="pickupTime" 
                                            disabled/>
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="12">
                            <a-form-model-item label="New Pickup Time" prop="newPickupTime">
                                <a-time-picker format="HH:mm" 
                                            :minuteStep="5"
                                            hideDisabledOptions
                                            inputReadOnly
                                            v-model="pickupTimeEditModel.newPickupTime" />
                            </a-form-model-item>
                        </a-col>
                    </a-row> 
                </a-form-model>
            </a-row>

            <a-row>
               
            </a-row>
        </a-modal>
       
    </div>
</template>

<script>
import moment from 'moment';
import TimeFormatter from '../../../common/utils/TimeFormatter'
export default {

    data () {
        let checkNewPickupTime = (rule, value, callback) => {
            console.log('checkNewPickupTime is Called!')
            let currentTime = moment();
            console.log(currentTime)
            console.log(value)
            if(value != null) {
                if (value.isBefore(currentTime)) {
                    this.isPickupTimeValid = false;
                    console.log(this.isPickupTimeValid)
                    callback(new Error('Pickup time is not valid!'));
                }
                else {
                    this.isPickupTimeValid = true;
                    console.log(this.isPickupTimeValid)
                    callback();
                }
            }
            else {
                callback(new Error('Pickup time is not valid!'));
            }
            
        }
        return {
            orderId : null,
            pickupTimeEditModel : {
                newPickupTime : null
            },
            isVisible : false,
            pickupTime : null,
            pickupTimeEditRules : {
                newPickupTime : [{ validator: checkNewPickupTime, trigger : 'change'}]
            },
            isPickupTimeValid : false
        }
    },
    
    methods : {

        show(record) {
            //console.log(order)
            this.isVisible = true;
            this.orderId = record.orderId;

            this.pickupTime = moment(record.pickupTime, 'HH:mm');
        },

        handleOk ()  {
            this.isVisible = false;
            this.reset();
        },
        handleBtnCancel () {
            this.isVisible = false;
            this.reset();
        },

        handleBtnUpdate() {
            
            this.$message.loading('Updating data...', 5);

            this.$refs.pickupTimeEditForm.validate(async valid => {

                if (valid) {
                    console.log('Valid!!!');
                    let record = {
                        orderId : this.orderId,
                        newPickupTime : this.pickupTimeEditModel.newPickupTime,
                    }
                    //console.log(record);
			        let isSuccess = await this.$store.dispatch('orderManager/updateOrderPickupTimeAction', record);
			
			        if(!isSuccess) {
				        this.$message.error('Something was wrong, please try again!', 5);
			        }
			        else {
					    this.$message.success('Update successfully!', 3);
			        }
                }
                else {
                    console.log('Invalid! Please check pickup time!')
                }
            });
            this.isVisible = false;
            this.reset();
			this.$message.destroy();
        },

      
        reset() {
            this.pickupTime = '';
            this.orderId = null;
            this.pickupTimeEditModel.newPickupTime = null;
        }
    }
}
</script>

<style>

</style>